import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

// Anonymer Aufrufzaehler: zaehlt jeden Seitenaufruf, speichert nichts im Browser, keine IP, kein Cookie.
const VisitCounter = () => {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    axios.post(`${API}/visits/hit`)
      .then(res => setTotal(res.data.total))
      .catch(() => {});
  }, []);

  if (total === null) return null;
  return (
    <div className="fixed bottom-1 right-3 z-30 text-[11px] text-slate-400 pointer-events-none select-none" data-testid="visit-counter">
      Aufrufe: {total.toLocaleString('de-DE')}
    </div>
  );
};

export default VisitCounter;
